import { FormattedMessage } from 'react-intl';
import { useLayoutPreferences } from 'routes/essential-workspace/components/right-panel/hooks/use-layout-preferences';

type FooterProps = {
  currentSectionId: string;
  setCurrentSection: (sectionId: string) => void;
  closePanel: () => void;
};

const Footer = ({ currentSectionId, setCurrentSection, closePanel }: FooterProps) => {
  const { resetToDefaultLayout, submitLayoutChanges, isSaving } = useLayoutPreferences({
    currentSectionId,
    setCurrentSection,
    closePanel,
  });

  return (
    <div className="offcanvas-footer d-flex p-3 gap-2 border-top">
      <button
        type="button"
        className="btn btn-link text-secondary text-decoration-none flex-grow-1 p-0"
        onClick={resetToDefaultLayout}
      >
        <FormattedMessage id="essential.workspace.right.panel.reset-default" />
      </button>
      <button
        type="button"
        className="btn btn-outline-primary rounded-0 px-5 flex-grow-1 essential-right-panel-done-btn"
        onClick={() => void submitLayoutChanges()}
        disabled={isSaving}
      >
        <FormattedMessage id="essential.workspace.right.panel.done" />
      </button>
    </div>
  );
};

export default Footer;
